import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import GenericPopup from './GenericPopup';

import './styles/ActionRejectedPopup.css';

export default function ActionRejectedPopup({
  open,
  close,
  title = 'Action Rejected',
  description = 'You do not have permission to perform this action. Please contact your gallery admin.',
}) {
  return (
    <GenericPopup
      open={open}
      className="required-action-popup remove-scrollbar"
      backgroundClassName="required-action-popup__background"
      opacity
    >
      <div className="required-action-popup__header">
        <Text className="required-action-popup__header-text">
          {title}
        </Text>
        <XIcon className="required-action-popup__close" onClick={close} />
      </div>
      <Text className="required-action-popup__text" paragraph justify>
        {description}
      </Text>
    </GenericPopup>
  );
}
